import axios from "axios";

const root = axios.create();
const api = axios.create({
  baseURL:
    "https://gato.tapiocahut.com/"
});
// comment: Criada essa nova instância para que as requisições de pagamento ocorram diretamente para a Lambda local, para testes do novo fluxo implementado, utilizando dados da produção
const api2 = axios.create({
  baseURL:
    "https://localhost:7179/",
});
const viacep = axios.create({
  baseURL: "https://viacep.com.br/ws/",
  withCredentials: false,
  crossdomain: true,
});
// Fallback quando o ViaCEP (comunitário, sem SLA) não reconhece um CEP que na verdade existe.
const opencep = axios.create({
  baseURL: "https://opencep.com/v1/",
  withCredentials: false,
  crossdomain: true,
});
const brasilapi = axios.create({
  baseURL: "https://brasilapi.com.br/api/cep/v2/",
  withCredentials: false,
  crossdomain: true,
});

export { api, viacep, opencep, brasilapi, root, api2 };
